<template>
  <div class="process_report">
    <vs-card id="data-loading">
      <!-- header -->
      <div class="flex items-center w-full my-3">
        <div class="w-full">
          <vs-button color="dark" class="float-right" type="filled" @click="$emit('download_excel_report')">Excel</vs-button>
        </div>
      </div>

      <!-- data -->
      <!-- general details -->
      <vs-table class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template>
          <vs-tr>
            <vs-td>OMMA License ID/Number</vs-td>
            <vs-td>{{ reports_data.parentUser.omma_license_number }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Role</vs-td>
            <vs-td>{{ reports_data.parentUser.role.role_name }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Email</vs-td>
            <vs-td>{{ reports_data.parentUser.email }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Phone Number</vs-td>
            <vs-td>{{ reports_data.parentUser.mobile }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Reporting Year</vs-td>
            <vs-td>{{ year }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td>Reporting Month</vs-td>
            <vs-td>{{ moment(month, 'M').format('MMMM') }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana on hand at the beginning of the reporting period. -->
      <vs-table ref="amountMarijuanaAtBeginning" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana on hand at the beginning of the reporting period.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section1.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana purchased from grower licensees. -->
      <vs-table ref="amountMarijuanaPurchasedFromGrower" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana purchased from grower licensees.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight/Count</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section2.flower_weight | weightFilter }} / {{ reports_data.section2.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section2.shake_trim_weight | weightFilter }} / {{ reports_data.section2.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section2.waste_weight | weightFilter }} / {{ reports_data.section2.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Immature Plant(s)</vs-td>
            <vs-td class="text__green font-semibold"> {{ reports_data.section2.immature_plant_weight | weightFilter }} / {{ reports_data.section2.immature_plant_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Mature Plant(s)</vs-td>
            <vs-td class="text__green font-semibold"> {{ reports_data.section2.mature_plant_weight | weightFilter }} / {{ reports_data.section2.mature_plant_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana purchased from processor licensees. -->
      <vs-table ref="amountMarijuanaPurchasedFromProcessor" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana purchased from processor licensees.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section3.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of medical marijuana manufactured or processed. -->
      <vs-table ref="amountMarijuanaManufactured" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of medical marijuana manufactured or processed.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section4.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana sold to dispensary. -->
      <vs-table ref="amountMarijuanaSoldToDispensary" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana sold to dispensary.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section5.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana sold to processor. -->
      <vs-table ref="amountMarijuanaSoldToProcessor" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana sold to processor.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section6.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana sold to researcher. -->
      <vs-table ref="amountMarijuanaSoldToResearcher" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana sold to researcher.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section7.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana sold total. -->
      <vs-table ref="amountMarijuanaSold" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana sold total.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section8.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana waste in pounds. -->
      <vs-table class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana waste in pounds.</p>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">{{ reports_data.section9 | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana transported to other licensed locations during this reporting month. -->
      <vs-table ref="amountMarijuanaTransported" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana transported to other licensed locations during this reporting month.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section10.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana transported to your business during this reporting month. -->
      <vs-table ref="amountMarijuanaTransportedToBussiness" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana transported to your business during this reporting month.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section11.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- All transporter IDs that have transported for your business this reporting month. -->
      <vs-table ref="marijuanaTransporter" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">All transporter IDs that have transported for your business this reporting month.</p>
        </template>

        <template>
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in reports_data.section12.transporters">
            <vs-td class="text__green font-bold">{{ tr }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <!-- The amount of marijuana on hand at the end of the reporting period. -->
      <vs-table ref="amountMarijuanaAtEnd" class="vs-con-loading__container" :sst="true" :data="[]" noDataText="">
        <template #header>
          <p class="text-sm italic font-semibold table_header mb-2">The amount of marijuana on hand at the end of the reporting period.</p>
        </template>

        <template slot="thead">
          <vs-th>#</vs-th>
          <vs-th>Weight in Pounds</vs-th>
          <vs-th>Count(unit)</vs-th>
        </template>

        <template>
          <vs-tr>
            <vs-td class="font-bold">Flower</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.flower_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.flower_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Shake</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.shake_trim_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.shake_trim_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Waste</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.waste_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.waste_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Suppository</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.suppository_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.suppository_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Extract</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.extract_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.extract_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Concentrate</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.concentrates_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.concentrates_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Edibles</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.edibles_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.edibles_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Tincture</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.tincture_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.tincture_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Topical</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.topical_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.topical_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Trans-dermal Patch</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.trans_dermal_patch_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.trans_dermal_patch_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Capsule</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.capsule_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.capsule_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Combined Category</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.combined_category_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.combined_category_count | weightFilter }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-td class="font-bold">Pre Rolls</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.pre_rolls_weight | weightFilter }}</vs-td>
            <vs-td class="text__green font-semibold">{{ reports_data.section13.pre_rolls_count | weightFilter }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { weightMixins } from '@/utils/weightType'

export default {
  name: 'ProcessorReportData',

  props: {
    year: Number,
    month: Number
  },

  mixins: [weightMixins],

  computed: {
    ...mapState('report', ['reports_data'])
  },

  methods: {
    moment
  },

  filters: {
    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(value || 0, 3)
    }
  }
}
</script>

<style lang="scss">
.process_report {
  .table_header {
    color: #337ab7;
  }
  .text__green {
    color: #3c763d;
  }
}
</style>